import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="coupon-input"
export default class extends Controller {
  sanitize(event) {
    const input = event.target
    if (!input) return

    input.value = input.value.toString().replace(/[^\d-]/g, "")
  }
}